import { ajax } from "@utils";
import { saveAs } from "file-saver";

export const managementFeeService = {
  getAll: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  get: (constructionUuid, id) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${id}`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  getSetting: constructionUuid => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/mgtf-settings`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  gerPeriodList: constructionUuid => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/list`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  publish: (constructionUuid, id, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${id}/publish`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  notifyUnpaidPeriodBills: (constructionUuid, id, info = {}) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${id}/notify`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  notifyUnpaidBill: (constructionUuid, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/bills-notify`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  getAllBills: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/bills`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  create: (constructionUuid, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  update: (constructionUuid, id, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${id}`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  delete: (constructionUuid, id) => {
    return ajax
      .delete(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${id}`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  updateBillPrintSetting: (constructionUuid, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/print-setting`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  createBillPaymentHistory: (constructionUuid, periodId, billId, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${periodId}/bills/${billId}/payments`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  updateBillPaymentHistory: (constructionUuid, periodId, billId, paymentHistoryId, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${periodId}/bills/${billId}/payments/${paymentHistoryId}`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  deleteBillPaymentHistory: (constructionUuid, periodId, billId, paymentHistoryId) => {
    return ajax
      .delete(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${periodId}/bills/${billId}/payments/${paymentHistoryId}`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  previewBill: (constructionUuid, periodId, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${periodId}/bills-export`,
        {
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...info })
        }
      )
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res);
        }
        return res.blob();
      })
      .then(blob => {
        const pdfUrl = URL.createObjectURL(blob);
        return pdfUrl;
      });
  },
  exportBill: (constructionUuid, periodId, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/${periodId}/bills-export`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res);
        }
        return res.blob();
      })
      .then(blob => {
        saveAs(blob, `${info.file_name}.pdf`);
      });
  },
  exportPayment: (constructionUuid, fileName, info) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/management-fee-periods/payments-export`,
        {
          params: {
            ...info
          }
        }
      )
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.blob();
      })
      .then(blob => {
        saveAs(blob, `${fileName}.xlsx`);
      });
  }
};
